import { render, staticRenderFns } from "./GECampaign.vue?vue&type=template&id=02939dd2&scoped=true&"
import script from "./GECampaign.vue?vue&type=script&lang=js&"
export * from "./GECampaign.vue?vue&type=script&lang=js&"
import style0 from "./GECampaign.vue?vue&type=style&index=0&id=02939dd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02939dd2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VIcon,VList,VSubheader,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\Jatin\\Documents\\Source\\wiom-dashboard\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02939dd2')) {
      api.createRecord('02939dd2', component.options)
    } else {
      api.reload('02939dd2', component.options)
    }
    module.hot.accept("./GECampaign.vue?vue&type=template&id=02939dd2&scoped=true&", function () {
      api.rerender('02939dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/GECampaign.vue"
export default component.exports